<template>
  <div class="page-header">
    <div class="panel-info">
      <a-affix class="affix-title" :target="affixTarget">
        <div class="panel-info-title">
          <h2 :title="data.name" class="text-ellipsis text-no-wrap overflow-hidden text-bold v-mr-sm">{{ data.name }}</h2>
          <div class="v-ml-auto">
            <slot name="actions" :data="data"></slot>
          </div>
        </div>
      </a-affix>
      <a-divider />
      <div class="w1200" v-if="showSteps">
        <div class="v-pa-lg v-mt-lg">
          <a-steps progress-dot :current="currentStep" size="small">
            <a-step title="项目申请">
              <div slot="description" style="white-space: nowrap; font-size: 12px">
                <div>{{ data.applyTime }}</div>
              </div>
            </a-step>
            <a-step title="项目审核">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="data.state > 1">
                <div>{{ data.reviewTime }}</div>
              </div>
            </a-step>
            <a-step title="筹款申请">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="data.state > 2">
                <div>{{ data.hzInfo && data.hzInfo.raiseTime }}</div>
              </div>
            </a-step>
            <a-step title="筹款审核">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="data.state > 3">
                <div>{{ data.hzInfo && data.hzInfo.raiseCheckTime }}</div>
              </div>
            </a-step>
            <a-step title="项目执行">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="data.state > 7">
                <div>{{ data.concludingTime }}</div>
              </div>
            </a-step>
            <a-step title="项目结项">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="data.state > 8">
                <div>{{ data.closeTime }}</div>
              </div>
            </a-step>
            <a-step title="完成" />
          </a-steps>
        </div>
      </div>
      
      <div class="flex items-center justify-between v-px-xs" v-if="showStat && data.state >= 7">
        <div class="card card-stats card-round">
          <div class="card-body">
            <div class="flex items-center">
              <div class="col-icon col-icon-big">
                <div class="icon-big text-center icon-red3 bubble-shadow-small">
                  <i class="fa fa-cube"></i>
                </div>
              </div>
              <div class="col col-stats">
                <div class="numbers">
                  <p class="card-category">预算金额</p>
                  <h4 class="card-title">
                    <span>{{ $utils.thousands(data.budgetAmount) }}</span>
                    元
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-stats card-round">
          <div class="card-body">
            <div class="flex items-center">
              <div class="col-icon col-icon-big">
                <div class="icon-big text-center icon-red3 bubble-shadow-small">
                  <i class="fa fa-cubes"></i>
                </div>
              </div>
              <div class="col col-stats">
                <div class="numbers">
                  <p class="card-category">筹款金额</p>
                  <h4 class="card-title">
                    <span>{{ $utils.thousands(data.raisedAmount) }}</span>
                    元
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-stats card-round">
          <div class="card-body">
            <div class="flex items-center">
              <div class="col-icon col-icon-big text-red">
                <div class="icon-big text-center icon-red3 bubble-shadow-small">
                  <i class="fa fa-podcast"></i>
                </div>
              </div>
              <div class="col col-stats">
                <div class="numbers">
                  <p class="card-category">请款金额</p>
                  <h4 class="card-title">
                    <span>{{ $utils.thousands(data.appliedAmount) }}</span>
                    元
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-stats card-round">
          <div class="card-body">
            <div class="flex items-center">
              <div class="col-icon col-icon-big">
                <div class="icon-big text-center icon-red3 bubble-shadow-small">
                  <i class="fa fa-money"></i>
                </div>
              </div>
              <div class="col col-stats">
                <div class="numbers">
                  <p class="card-category ellipsis">实际支出金额</p>
                  <h4 class="card-title">
                    <span>{{ $utils.thousands(data.expensedAmount) }}</span>
                    元
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card-stats card-round">
          <div class="card-body">
            <div class="flex items-center">
              <div class="col-icon col-icon-big">
                <div class="icon-big text-center icon-red3 bubble-shadow-small">
                  <i class="fa fa-adjust"></i>
                </div>
              </div>
              <div class="col col-stats">
                <div class="numbers">
                  <p class="card-category">请款余额</p>
                  <h4 class="card-title">
                    <span>{{ $utils.thousands(data.appliedAmount - data.expensedAmount) }}</span>
                    元
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <slot name="tips" :data="data"></slot>
    </div>
    <div class="v-px-sm" v-if="showTabs">
      <a-tabs type="card" v-model="tab" @change="onTabChange">
        <a-tab-pane key="basic" tab="项目信息" />
        <a-tab-pane key="budget" tab="项目预算表" v-if="data.state < 7 "/>
        <a-tab-pane key="raise" tab="筹款申请" v-if="data.state > 1" />
        <template v-if="data.state >= 7">
          <a-tab-pane key="plan" tab="项目计划" />
          <a-tab-pane key="finance" tab="财务信息" />
          <a-tab-pane key="report" tab="项目报告" />
          <a-tab-pane key="changeinfo" tab="项目变更" />
        </template>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import { viewPrj } from '@/api/project/funded'
export default {
  name: 'ProjectPageHeader',
  props: {
    id: {
      type: Number,
      required: true,
    },
    showSteps: {
      type: Boolean,
      default: false,
    },
    showTabs: {
      type: Boolean,
      default: false,
    },
    showStat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      projectId: undefined,
      currentStep: 0,
      data: {},
      // tabs: [],
      tab: '',
    }
  },
  watch: {
    id() {
      this.init()
    },
    $route() {
      this.initTabKey()
    },
  },
  methods: {
    init() {
      this.projectId = this.id
      this.load()
      this.initTabKey()
    },
    initTabKey() {
      this.tab = this.$route.path.split('/').slice(-1)[0]
    },
    onTabChange(path) {
      this.$router.push({ path, query: { id: this.projectId } })
    },
    load() {
      viewPrj(this.projectId).then(({ data }) => {
        if (data.success) {
          let { state } = data.result
          this.data = data.result
          this.currentStep = state >= 7 ? state - 3 : state
          this.initTabKey()
          this.$store.dispatch('setProject', data.result)
        }
      })
    },
  },
  created() {
    this.init()
  },
}
</script>
